import React from "react"
import { Avatar, Icon } from "n2-styles"

const AreaDirectorPublicationJobsIndex = ({ data }) => {
  const rows = data.map((job) => {
    return (
      <a key={job.index} className="list-group-item u-hover--raised" href={job.href}>
        <div className="d-flex w-100 align-items-center cursor-pointer row">
          <div className="d-flex flex-column align-content-center mx-3">
            <Avatar user={job.avatar} />
          </div>

          <div className="d-flex flex-column col-5 col-sm-3">
            {job.publication_name}
            <small className="grey-text">{job.territory_name}</small>
          </div>

          <div className="d-none d-sm-flex flex-column grey-text col u-wrap">
            <small>{job.deadline_day}</small>
            <small>{job.publish_date}</small>
            <small>{job.nice_status}</small>
          </div>

          <div className="d-none d-sm-flex flex-column grey-text col u-wrap">
            <small>{job.page_count} Pages</small>
            <small>{job.article_count} Articles </small>
            <small>{job.ad_count} Ads</small>
          </div>

          <small className="d-none d-lg-flex flex-column grey-text col-2 u-wrap" title={job.modified_at}>
            {job.formatted_modified_at}
          </small>

          <div className="d-flex grey-text flex-column col-1 align-items-center ml-auto">
            <Icon icon="keyboard_arrow_right" label="See more" />
          </div>
        </div>
      </a>
    )
  })

  return (
    <ul className="list-group list-group-flush mb-6">
      {rows}
    </ul>
  )
}

export default AreaDirectorPublicationJobsIndex
